export default {
  data() {
    return {
      workspaceFiltrosResources: this.$api.workspaceFiltros(this.$resource),
      workspace: {},
    };
  },
  methods: {
    carregarWorkspace(entidade, cb) {
      return this.workspaceFiltrosResources
        .pesquisar({ entidade })
        .then((response) => {
          this.workspace = response.data || {};
          if (cb && this.workspace && this.workspace.filtros) {
            cb(this.workspace.filtros);
          }
        });
    },
    salvarWorkspace(entidade, filtros = {}, idEntidade = null) {
      if (this.workspace.id) {
        this.atualizarWorkspace(entidade, filtros, idEntidade);
      } else {
        this.inserirWorkspace(entidade, filtros, idEntidade);
      }
    },
    inserirWorkspace(entidade, filtros = {}, idEntidade = null) {
      this.workspace.idEntidade = idEntidade;
      this.workspace.filtros = filtros;

      this.workspaceFiltrosResources
        .inserir({ entidade }, this.workspace)
        .then((response) => {
          this.workspace.id = response.data;
        });
    },
    atualizarWorkspace(entidade, filtros = {}, idEntidade = null) {
      this.workspace.idEntidade = idEntidade;
      this.workspace.filtros = filtros;

      this.workspaceFiltrosResources
        .atualizar({ entidade }, this.workspace);
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/functions/workspace-filtros.js